import styled from '@emotion/styled'
import * as React from 'react'
import { NavigationBarContext, NavigationBarContextState } from './NavigationBarContext'

const NavigationBarRoot = styled.div`
  width: 100%;
  min-height: 70px;
  height: 70px;
  background: linear-gradient(90deg, #88288f 44.48%, #71d8c6 99.31%), #491156;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const NavigationBar = (p: React.PropsWithChildren) => {
  const [state, setState] = React.useState<NavigationBarContextState>({
    megaMenu: {
      isOpen: false,
      routes: [],
    },
  })

  return (
    <NavigationBarContext.Provider value={{ state, setState }}>
      <NavigationBarRoot className="NavigationBarRoot">{p.children}</NavigationBarRoot>
    </NavigationBarContext.Provider>
  )
}
